import * as React from "react"
import Footer from "../components/footer"
import Navbar from "../components/navbar"
import Amare from "../components/sections/amare"

/*
 * Amaré now lives on the home page, which is one scrolling document. This
 * route is kept so links to /amare/ shared before the merge still resolve —
 * the studio's Instagram bio among them. It renders the same section, on its
 * own. Nothing on the site links here any more; the footer and the navbar
 * both point at /#amare.
 */
export default function AmarePage() {
  return (
    <React.Fragment>
      <Navbar />
      <Amare />
      <Footer />
    </React.Fragment>
  )
}
